import React, { useState } from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { ActionTable, BigTitle, CommentWrapper, CriteriaHeader, CriteriaHeading, EvaluationGroup, EvaluationTeamTable, ExecOverview, ExecutiveSummary, Heading, IntrerviewsTable, StandardsTable, TopPage } from './comps';
import { reportTypeName } from '../../api/types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { draftData } from '../../containers/ReportEditor/staticReportData';
import { formatMonthYear, formatToYear, genUID } from '../../common/StaticExports';
import Html from 'react-pdf-html';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  }
});

// Create Document Component
const RenderDocument = (props:any) => {
    const { data, staffData, esRichText, imageUrl } = props;
    const [t] = useTranslation();
    const [pageNumExecutiveSummary, setPageNumExecutiveSummary] = useState(0);
    const appendixActions = data?.Criteria.flatMap((c:any) =>
        c?.Standards?.flatMap((s:any) => s?.Actions)
    );

    return (
        <Document>
          {/* TOP PAGE */}
          <Page style={styles} wrap={false}>
              <TopPage
              name={data.ClubName + ' ' + data.ExecutiveSummary.Year}
              japName={data.JapaneseClubName}
              imageUrl={data.ImageBase64}
              // imageUrl={imageUrl}
              title={`${data.ExecutiveSummary.Year} CLUB REPORT`}
              reportType={t(reportTypeName[1])}
              reportDate={formatMonthYear(data.ReportDate)}
              />
          </Page>
          <Page style={{ paddingVertical: 70, paddingHorizontal: 30 }} >
              {/* EXECUTIVE SUMMARY */}
              <>
                <Heading label={t('EXECUTIVE_SUMMARY').toUpperCase()}/>
                <ExecutiveSummary 
                  targetTitle={t('TARGET')}
                  achievedTitle={t('ACHIEVED')}
                  target={data?.ExecutiveSummary.TargetStarRating}
                  acheived={data?.ExecutiveSummary.AchievedStarRating}
                />
                <View wrap={true} style={{ backgroundColor: '#f2f2f3', paddingVertical: 3, paddingHorizontal: 6, marginTop: 6, fontSize: 12, minHeight: 100 }}>
                  <Text>
                    <Html style={{ fontSize: 12 }}>{esRichText}</Html>
                  </Text>
                </View>
              </>
          </Page>
          {/* Criteria Details */}
          {
            data?.Criteria && data?.Criteria.map((criteria:any, idx:any) => {
              const actionData = criteria?.Standards?.flatMap((d:any) => d?.Actions);
              return (
                <Page style={{ paddingVertical: 70, paddingHorizontal: 30 }} >
                    <>
                    {/* commented criteria group header, waiting for new design */}
                      {/* <EvaluationGroup reportData={data} criteria={criteria} /> */}
                      <CriteriaHeader criteria={criteria}/>
                      <StandardsTable data={criteria?.Standards}/>
                      <CommentWrapper data={{CriteriaComment: 'This is a sample criteria comment', UpdatedDate: '2025-10-12'}}/>
                      {
                        actionData && actionData?.length > 0 &&
                        <ActionTable data={actionData} staffList={staffData}/>
                      }
                    </>
                </Page>
              )
            })
          }
          {/* appendix page */}
          <Page style={{ paddingVertical: 70, paddingHorizontal: 30 }} >
            <Heading label={t('APPENDIX').toUpperCase()}/>
            <CriteriaHeading label={t('ACTIONS').toUpperCase()}/>
            <ActionTable data={appendixActions} staffList={staffData}/>
            <CriteriaHeading label={t('INTERVIEWS').toUpperCase()}/>
            <IntrerviewsTable data={data?.Sessions}/>
            <CriteriaHeading label={t('EVALUATION_TEAM').toUpperCase()}/>
            <EvaluationTeamTable data={data?.EvaluationTeam}/>
          </Page>
        </Document>
      )
};

export default RenderDocument;